import { LazyLoadImage } from "react-lazy-load-image-component";
import { IoIosClose } from "react-icons/io";
import styles from "../../styles/shared/other-coins-signal/SelectedAssetsList.module.css";

function SelectedAssetsList({ selectedAssets, changeSelectedAssets }) {
  const isSelected = selectedAssets?.length > 0;

  const handleRemoveAsset = (asset) => () => {
    changeSelectedAssets((prevAssets) =>
      prevAssets.filter((assetId) => assetId !== asset),
    );
  };

  return (
    <div className={styles.container}>
      {isSelected && (
        <ul className={styles.assetsList}>
          {selectedAssets?.map((asset, index) => (
            <li key={asset} className={styles.assetItem}>
              <div className={styles.assetName}>
                <LazyLoadImage
                  src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/symbol_icons/${asset?.replace("/USDT", "")}.png`}
                  alt={asset}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/placeholders/asset-logo.svg";
                  }}
                  width="15px"
                  height="15px"
                  effect="blur"
                  style={{ borderRadius: "50%" }}
                />
                <span>{asset}/USDT</span>
              </div>
              <span
                className={styles.closeBtn}
                onClick={handleRemoveAsset(asset)}
              >
                <IoIosClose />
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SelectedAssetsList;
